import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { Suspense, lazy } from "react";
import { Routes, Route } from "react-router-dom";
var LoginCallback = /*#__PURE__*/lazy(function () {
  return import("pages/loginCallback/LoginCallback");
});
var Login = /*#__PURE__*/lazy(function () {
  return import("pages/login/Login");
});
import compareRoutes from "./compareRoutes";
import genericRoutes from "./genericRoutes";
import Header from "@domain-ui/header";
import { MissingPage, UnAuthorized } from "pages/errors";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function UnauthenticatedApp(props) {
  return /*#__PURE__*/_jsxs(Suspense, {
    fallback: /*#__PURE__*/_jsx("div", {
      children: "Loading..."
    }),
    children: [/*#__PURE__*/_jsx(Header, {}), /*#__PURE__*/_jsxs(Routes, {
      children: [/*#__PURE__*/_jsx(Route, {
        path: "/login",
        element: /*#__PURE__*/_jsx(Login, _objectSpread({}, props))
      }), /*#__PURE__*/_jsx(Route, {
        path: "/login/externalLoginCallback",
        element: /*#__PURE__*/_jsx(LoginCallback, _objectSpread({}, props))
      }), /*#__PURE__*/_jsx(Route, {
        path: "/admin/*",
        element: /*#__PURE__*/_jsx(UnAuthorized, {})
      }), genericRoutes(props), compareRoutes(props), /*#__PURE__*/_jsx(Route, {
        element: /*#__PURE__*/_jsx(MissingPage, {})
      })]
    })]
  });
}